// @flow
import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

import Scrollable from '../../components/shared/Scrollable';
import { colors } from '../../shared/styles';

const ListContent = styled.div`
    .list-content {
        height: calc(100vh - 152px);
        padding-bottom: 70px;
    }

    .simplebar-content {
        overflow-x: hidden;
    }
`;

const StyledTable = styled.table`
    max-width: 100%;
    width: 100%;
    text-align: left;

    &,
    tbody,
    tfoot,
    thead,
    tr,
    th,
    td {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        vertical-align: baseline;
        border-collapse: collapse;
        border-spacing: 0;
    }

    & {
        width: 100%;
    }

    thead {
        background: #edf1f2;
        overflow: hidden;
        border-bottom: 1px solid #d9d9db;
    }

    th {
        box-sizing: border-box;
        width: calc((100% - 100px) / 3);
        font-weight: normal;
        text-align: left;
        padding: 15px 20px;

        &:last-of-type {
            width: 95px;
        }
    }

    tbody {
        tr {
            font-weight: lighter;
            background: #f3f3f5;

            &:nth-of-type(odd) {
                background: ${colors.white};
            }
        }
    }

    td {
        padding: 10px 20px;
    }

    .btn {
        display: block;
        padding: 4px 15px;
        color: #fff;
        text-decoration: none;
        background: #e76424;
        border: none !important;
        font-weight: lighter !important;
        font-size: 14px !important;
        cursor: pointer;
    }

    .actions {
        width: 20%;
        text-align: right;

        .action-btn:last-child {
            margin-right: 0;
        }
    }

    .actions a,
    .actions button {
        position: relative;
        display: inline-block;
        margin: 8px 8px 8px 0;
        padding: 5px 8px;
        color: #fff;
        text-decoration: none;
        background: #e76424;
        border: none !important;
        font-weight: lighter !important;
        font-size: 14px !important;
        line-height: 16px !important;
        cursor: pointer;
        border-radius: 4px;
        border: none;
    }

    .action-btn .tooltip {
        position: absolute;
        font-size: 12px;
        width: 140px;
        color: #ffffff;
        background: #48555b;
        height: 30px;
        line-height: 30px;
        text-align: center;
        visibility: hidden;
        border-radius: 4px;
    }

    .action-btn .tooltip-wide {
        width: 200px;
    }

    .action-btn .tooltip:after {
        content: '';
        position: absolute;
        top: 50%;
        left: 100%;
        margin-top: -8px;
        width: 0;
        height: 0;
        border-left: 8px solid #48555b;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
    }

    .action-btn:hover .tooltip {
        visibility: visible;
        right: 100%;
        top: 50%;
        margin-top: -15px;
        margin-right: 13px;
        z-index: 999;
    }
`;

const List = (props: {
    contactRequests: Object,
    onContactRequest: Function,
    onDelete: Function,
}) => {
    const { contactRequests, onContactRequest, onDelete } = props;

    return (
        <ListContent>
            <Scrollable additionalClassName="list-content">
                <StyledTable>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Telephone</th>
                            <th>Region</th>
                            <th>Created At</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        {contactRequests
                            ? Object.keys(
                                  contactRequests
                              ).map(contactRequestId => {
                                  const contactRequest =
                                      contactRequests[contactRequestId];
                                  return (
                                      <tr key={contactRequestId}>
                                          <td>
                                              {
                                                  contactRequest.contactRequestName
                                              }
                                          </td>
                                          <td>
                                              {
                                                  contactRequest.contactRequestEmail
                                              }
                                          </td>
                                          <td>
                                              {contactRequest.contactRequestTelephone
                                                  ? contactRequest.contactRequestTelephone
                                                  : ''}
                                          </td>
                                          <td>
                                              {contactRequest.region &&
                                              contactRequest.region
                                                  .contactRequestRegionSlug
                                                  ? contactRequest.region
                                                        .contactRequestRegionName
                                                  : ''}
                                          </td>
                                          <td>
                                              {moment(
                                                  contactRequest.contactRequestCreatedAt
                                              ).format('DD/MM/YYYY')}
                                          </td>
                                          <td className="actions">
                                              <button
                                                  className="action-btn"
                                                  onClick={e => {
                                                      onContactRequest(
                                                          contactRequestId
                                                      );
                                                  }}
                                              >
                                                  <i className="fa fa-eye" />
                                                  <span className="tooltip">
                                                      View Details
                                                  </span>
                                              </button>
                                              <button
                                                  className="action-btn"
                                                  onClick={() => {
                                                      onDelete(contactRequest);
                                                  }}
                                              >
                                                  <i className="fa fa-trash" />
                                                  <span className="tooltip">
                                                      Delete
                                                  </span>
                                              </button>
                                          </td>
                                      </tr>
                                  );
                              })
                            : null}
                    </tbody>
                </StyledTable>
            </Scrollable>
        </ListContent>
    );
};

export default List;



// WEBPACK FOOTER //
// ./src/components/ContactRequests/List.js